import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    country: [],
    language: [], 
    timezone:[]
}


const dataSlice = createSlice({
    name: 'CountriesTimezonesLanguages',
    initialState,
    reducers: {
        setInformationData: (state, action) => {
            const {
                country = [],
                timezone = [],
                language = [],
            } = action.payload ?? {}

            state.country = Array.isArray(country) ? country : []
            state.timezone = Array.isArray(timezone) ? timezone : []
            state.language = Array.isArray(language) ? language : []
        }
    }
})

export const { setInformationData } = dataSlice.actions

export default dataSlice.reducer 
